import DatePicker from 'vue2-datepicker';
import * as $ from 'jquery';

export default {
    name: 'TrackingFilterModal',
    components: {
		DatePicker
	},
    props: {
		intervalOptions: {
			type: Array,
			required: true
		}
	},
    data() {
        return {
			modal: {
				dateRange: [
					new Date(new Date() - (7 * 86400000)),
					new Date()
				],
				interval: {
					value: '10 minute'
				}
			}
        }
    },
    computed: {
		selectedInterval(){
			return this.modal.interval.value;
		}
	},
    mounted() {
        $(this.$refs.trackingFilterModal).on('hidden.bs.modal', () => {
			this.$emit('closeModal');
		});
	},
	beforeDestroy() {
        this.closeModal();
	},
    methods: {
		show() {
            $('#trackingModal').modal('show');
        },
        closeModal() {
            $('#trackingModal').modal('hide');
        },
		onSelectedInterval(interval) {
			this.modal.interval = interval;
		},
		setIntervals() {
			this.$emit('onEmitSelectedInterval', this.modal.dateRange);
			setTimeout(() => {
				this.modal.interval = this.intervalOptions[0];
			}, 200);
		},
		submitFilter() {
			this.$emit('onSubmitFilter', this.modal);
			this.closeModal();
		}
	}
}